import React from 'react';
import { Icon } from '@groupby/ui-components';
import { getColor } from '@/search-for-retail/generic';
export const UploadIcon = ({ width = 24, height = 24, color, disabled, }) => <Icon variant="add" color={getColor(disabled, color)} width={width} height={height}/>;
export default UploadIcon;
